
import React from 'react';
import { useRotaForm } from '../context/RotaContext';

const Step6Settings = () => {
  const { formData, updateField } = useRotaForm();

  const ToggleSwitch = ({ checked, onChange }) => (
    <button 
      type="button"
      onClick={() => onChange(!checked)}
      className={`w-11 h-6 flex items-center rounded-full p-1 transition-colors duration-200 focus:outline-none ${checked ? 'bg-blue-600' : 'bg-gray-300'}`}
    >
      <div className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${checked ? 'translate-x-5' : 'translate-x-0'}`} />
    </button>
  );

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold">6</div>
        <h2 className="text-lg font-semibold text-gray-900">Additional Settings (Optional)</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="flex items-center justify-between border border-gray-100 p-3 rounded-lg">
          <div>
            <p className="text-sm font-medium text-gray-800">Allow staff to swap shifts?</p>
            <span className="text-xs text-gray-500">{formData.allowSwap ? 'Yes' : 'No'}</span>
          </div>
          <ToggleSwitch checked={formData.allowSwap} onChange={(val) => updateField('allowSwap', val)} />
        </div>

        <div className="flex items-center justify-between border border-gray-100 p-3 rounded-lg">
          <div>
            <p className="text-sm font-medium text-gray-800">Require manager approval?</p>
            <span className="text-xs text-gray-500">{formData.requireApproval ? 'Yes' : 'No'}</span>
          </div>
          <ToggleSwitch checked={formData.requireApproval} onChange={(val) => updateField('requireApproval', val)} />
        </div>

        <div className="flex items-center justify-between border border-gray-100 p-3 rounded-lg">
          <div>
            <p className="text-sm font-medium text-gray-800">Lock rota after publication?</p>
            <span className="text-xs text-gray-500">{formData.lockAfterPublish ? 'Yes' : 'No'}</span>
          </div>
          <ToggleSwitch checked={formData.lockAfterPublish} onChange={(val) => updateField('lockAfterPublish', val)} />
        </div>
      </div>
    </div>
  );
};

export default Step6Settings;

